import { TableCell, TableHead, TableRow, TableSortLabel } from '@mui/material';
import BaseCheckbox from '../base-checkbox/BaseCheckbox';
import { SortTableIcon } from '~/assets/icons';
import { memo } from 'react';
import { SortDirection } from '~/utils/types/job';

type BaseTableHeadProps = {
  numSelected: number;
  onRequestSort: (event: React.MouseEvent<unknown>, property: string) => void;
  onSelectAllClick: (event: React.ChangeEvent<HTMLInputElement>) => void;
  order: SortDirection;
  orderBy: string;
  rowCount: number;
  headCells: Array<{
    id: string;
    label: string;
    sortable: boolean;
  }>;
};

const BaseTableHead = (props: BaseTableHeadProps) => {
  const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort, headCells }: BaseTableHeadProps =
    props;
  const createSortHandler = (property: string) => (event: React.MouseEvent<unknown>) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow className='text-center bg-[#F1F4FF]'>
        <TableCell padding='checkbox' className='text-center'>
          {/*<BaseCheckbox
            className='w-[20px] h-[20px]'
            color='primary'
            indeterminate={false}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
          />*/}
        </TableCell>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id as string}
            align={'left'}
            padding={'none'}
            sortDirection={orderBy === headCell.id ? (order.toLowerCase() as 'asc' | 'desc') : false}
            className='text-center'
          >
            <TableSortLabel
              IconComponent={() => headCell.sortable ? <SortTableIcon className='ml-[32px] w-[19px] h-[19px]' /> : null }
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? (order.toLowerCase() as 'asc' | 'desc') : 'asc'}
              onClick={headCell.sortable ? createSortHandler(headCell.id) : undefined}
            >
              {headCell.label}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default memo(BaseTableHead);
